<div style="width: 100% !important;

        height: 100% !important;">
  <canvas #pi_chart ></canvas>
</div>

